import React from 'react'
import { Result} from 'antd';

const Fail=()=>{

    return <>
    <Result
    status="error"
    title="数据验证失败！"
    subTitle="经查证，没有对应的追溯单元，请严防假冒！"  
  >
    
  </Result>
    
    
    </>
}

export default Fail;